import React, { Component } from "react";

import InputMask from "react-input-mask";
import API from "../../../actions/api-helper";
import UI from "../../../actions/ui-helper";

class CadastroPaciente extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.handleChange = this.handleChange.bind(this);
    this.buscarPaciente = this.buscarPaciente.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      idCismepar: "",
      cpf: "",
      nome: "",
      dataNascimento: "",
      endereco: {
        estado: "",
        cidade: "",
      },
    };
  }

  componentDidUpdate() {
    if (!this.props.paciente) {
      this.props.onChange(this.getInitialState());
    } else if (this.props.paciente.id !== this.state.id) {
      this.setState(this.props.paciente);
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  buscarPaciente(event) {
    let idCismepar = event.target.value;
    if (!idCismepar) {
      UI.alert(
        false,
        "É necessário digitar o ID Cismepar do paciente para registrar um atendimento."
      );
      return;
    }

    UI.loader("show", "Um momento...");
    API.get("/pacientes/cismepar/" + idCismepar)
      .then(
        function (json) {
          if (!json.data.dataNascimento) json.data.dataNascimento = "";
          this.props.onChange(json.data);
          this.setState(json.data);
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">PACIENTE</h4>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>ID Cismepar</label>
                  <input
                    placeholder="ID Cismepar"
                    name="idCismepar"
                    className="form-control"
                    value={this.state.idCismepar}
                    onChange={this.handleChange}
                    onBlur={this.buscarPaciente}
                  />
                </div>
                <div className="col-md-3">
                  <label>CPF</label>
                  <InputMask
                    readOnly
                    placeholder="CPF"
                    name="cpf"
                    className="form-control"
                    mask="999.999.999-99"
                    value={this.state.cpf}
                  />
                </div>
                <div className="col-md-6">
                  <label>Nome</label>
                  <input
                    readOnly
                    placeholder="NOME"
                    name="nome"
                    className="form-control"
                    value={this.state.nome}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Estado (Origem)</label>
                  <input
                    readOnly
                    placeholder="Estado"
                    name="estado"
                    className="form-control"
                    value={this.state.endereco.estado}
                  />
                </div>
                <div className="col-md-3">
                  <label>Cidade (Origem)</label>
                  <input
                    readOnly
                    placeholder="CIDADE"
                    name="cidade"
                    className="form-control"
                    value={this.state.endereco.cidade}
                  />
                </div>
                <div className="col-md-3">
                  <label>Data Nascimento</label>
                  <InputMask
                    readOnly
                    type="text"
                    placeholder="DATA NASCIMENTO"
                    name="dataNascimento"
                    className="form-control"
                    mask="99/99/9999"
                    value={this.state.dataNascimento}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroPaciente;
